import createIcon from '@/lib/create-icon'

const LacrosseIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M16.131 29.8753C17.0329 28.9734 24.9403 26.4871 29.6839 25.8095M16.131 29.8753C17.0329 28.9734 19.5192 21.066 20.1968 16.3225M16.131 29.8753L14.0966 31.9068M27.6679 4.78503L41.2208 18.3379M22.2468 10.2062L35.7996 23.7591M41.5591 9.18925L26.6509 24.0974M36.8156 4.44574L21.9074 19.3539M39.1704 21.7437C34.3052 26.609 27.0238 27.2158 22.907 23.099C18.7902 18.9822 19.397 11.7008 24.2623 6.83553C29.1275 1.97025 36.4089 1.36347 40.5257 5.48025C44.6425 9.59702 44.0357 16.8784 39.1704 21.7437ZM11.584 32.2514L10.6353 32.3869C9.81423 32.5042 9.05334 32.8847 8.46685 33.4712L3.27158 38.6664C2.52308 39.4149 2.52308 40.6285 3.27158 41.377L4.62687 42.7323C5.37538 43.4808 6.58894 43.4808 7.33745 42.7323L12.5327 37.537C13.1192 36.9505 13.4997 36.1896 13.6169 35.3686L13.7525 34.4199C13.9332 33.1549 12.849 32.0707 11.584 32.2514Z'
      stroke='url(#paint0_linear_5314_410)'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M16.131 29.8753C17.0329 28.9734 24.9403 26.4871 29.6839 25.8095M16.131 29.8753C17.0329 28.9734 19.5192 21.066 20.1968 16.3225M16.131 29.8753L14.0966 31.9068M27.6679 4.78503L41.2208 18.3379M22.2468 10.2062L35.7996 23.7591M41.5591 9.18925L26.6509 24.0974M36.8156 4.44574L21.9074 19.3539M39.1704 21.7437C34.3052 26.609 27.0238 27.2158 22.907 23.099C18.7902 18.9822 19.397 11.7008 24.2623 6.83553C29.1275 1.97025 36.4089 1.36347 40.5257 5.48025C44.6425 9.59702 44.0357 16.8784 39.1704 21.7437ZM11.584 32.2514L10.6353 32.3869C9.81423 32.5042 9.05334 32.8847 8.46685 33.4712L3.27158 38.6664C2.52308 39.4149 2.52308 40.6285 3.27158 41.377L4.62687 42.7323C5.37538 43.4808 6.58894 43.4808 7.33745 42.7323L12.5327 37.537C13.1192 36.9505 13.4997 36.1896 13.6169 35.3686L13.7525 34.4199C13.9332 33.1549 12.849 32.0707 11.584 32.2514Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M16.131 29.8753C17.0329 28.9734 24.9403 26.4871 29.6839 25.8095M16.131 29.8753C17.0329 28.9734 19.5192 21.066 20.1968 16.3225M16.131 29.8753L14.0966 31.9068M27.6679 4.78503L41.2208 18.3379M22.2468 10.2062L35.7996 23.7591M41.5591 9.18925L26.6509 24.0974M36.8156 4.44574L21.9074 19.3539M39.1704 21.7437C34.3052 26.609 27.0238 27.2158 22.907 23.099C18.7902 18.9822 19.397 11.7008 24.2623 6.83553C29.1275 1.97025 36.4089 1.36347 40.5257 5.48025C44.6425 9.59702 44.0357 16.8784 39.1704 21.7437ZM11.584 32.2514L10.6353 32.3869C9.81423 32.5042 9.05334 32.8847 8.46685 33.4712L3.27158 38.6664C2.52308 39.4149 2.52308 40.6285 3.27158 41.377L4.62687 42.7323C5.37538 43.4808 6.58894 43.4808 7.33745 42.7323L12.5327 37.537C13.1192 36.9505 13.4997 36.1896 13.6169 35.3686L13.7525 34.4199C13.9332 33.1549 12.849 32.0707 11.584 32.2514Z'
      stroke='url(#paint1_radial_5314_410)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_410'
        x1='2.71021'
        y1='2.74951'
        x2='49.0593'
        y2='34.938'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_410'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9833 43.2937) scale(20.2731 20.6466)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'LacrosseIcon'
)

export default LacrosseIcon
